import { useContent } from "@/context/ContentContext";

export default function DigitalEdition() {
  const content = useContent();
  return (
    <div data-testid="digital-edition-page" className="bg-white">
      <iframe
        src={content.flipbook_url}
        title="BSD Digital Edition"
        data-testid="flipbook-iframe"
        allowFullScreen
        className="w-full block"
        style={{ height: "calc(100vh - 81px)", border: "none" }}
      />
    </div>
  );
}
